import { Component, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { LoginService } from 'src/app/services/login.service';
import { StorageService } from 'src/app/services/storage.service';


@Component({
    selector: 'app-admin-enterprise-wallet-balance-page',
    templateUrl: './admin-enterprise-wallet-balance-page.component.html',
    styleUrls: ['./admin-enterprise-wallet-balance-page.component.css']
})
export class AdminEnterpriseWalletBalancePageComponent implements OnInit {
    id!: string;
    supplierId!: number | undefined;

    sessionUser$ = this.loginService.sessionUser.asObservable();

    constructor(
        public loginService: LoginService,
        private storageService: StorageService,
    ) { }

    ngOnInit() {
        this.sessionUser$
            .pipe(take(1))
            .subscribe((user) => {
                if (user?.enterprise) {
                    console.log("User's enterprise:", user.enterprise); // Debug log to check enterprise details
                    this.id = user.enterprise.enterpriseId;
                    this.supplierId = this.storageService.getEnterpriseProfile()?.supplier?.id ?? undefined;
                    console.log("Extracted supplierId:", this.supplierId); // Debug log to check extracted supplierId
                }
            });
    }

}
